<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md4 lg3 xl3>
        <v-card flat class="elevation-5 pa-5">
          <v-card-title primary-title>
            <h2 class="font-weight-light">
              Вход в систему
            </h2>
          </v-card-title>
          <v-card-text class="pt-5">
            <v-form ref="form">
              <v-text-field
              autocomplete
              name="login"
              v-model="email"
              type="text"
              label="логин"
              required
              outlined
              append-icon="alternate_email"
              :disabled="resetkey !== null"
              @keyup.enter="$refs.ipassword.focus"
              ></v-text-field>
              <v-text-field
              autocomplete
              name="password"
              ref="ipassword"
              v-model="password"
              label="пароль"
              type="password"
              required
              outlined
              append-icon="lock"
              ></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!resetkey"
                small text color="secondary"
                @click="restorePassword"
                :disabled="!validEmail || restoreBlocked">
                  восстановить пароль
                </v-btn>
                <v-flex v-else>
                  <i class="grey--text">используется ключ восстановления</i>
                </v-flex>
              </v-card-actions>
              <br />
              <v-btn block large color="primary" @click="login" :disabled="!valid">
                Продолжить
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// eslint-disable-next-line
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export default {
  name: 'login',
  data: () => ({
    email: null,
    password: null,
    restoreBlocked: false,
    resetkey: null
  }),
  computed: {
    validEmail () {
      if (!this.email) return false
      return emailRe.test(this.email)
    },
    validPassword () {
      if (!this.password) return false
      if (this.password.length < 4) return false
      return true
    },
    valid () {
      return this.validEmail && this.validPassword
    }
  },
  methods: {
    async login () {
      try {
        if (!this.valid) return
        const resetkey = this.resetkey
        const email = this.email
        const password = this.password
        this.$store.dispatch('login', { email, password, resetkey })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    restorePassword () {
      this.$store.dispatch('sioRequest', {
        topic: 'auth-reset-password',
        pl: {
          email: this.email,
          domain: this.$store.state.domain
        }
      }).then((result) => {
        this.$store.dispatch('snack', result.meta.msg)
        this.restoreBlocked = true
      }).catch(err => {
        this.$store.dispatch('snack', err)
      })
    }
  },
  mounted () {
    // localStorage.removeItem('cafeadminToken')
    this.email = this.$route.query.email
    if (!this.email) return
    this.restoreBlocked = true
    this.resetkey = this.$route.query.resetkey
  }
}
</script>
